import { Card, Heading, Stack, Text } from "@softmax/design-system";
import { fonts, fontSizes } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import { PolicyStateFeedback, type PolicyRefreshState } from "../policy-state";

export type PolicyVersionScoreProps = {
  readonly score:
    | { readonly status: "loading" }
    | { readonly status: "error"; readonly message: string }
    | { readonly status: "empty" }
    | {
        readonly status: "ready";
        readonly value: string;
        readonly episodes: number;
        readonly refresh?: PolicyRefreshState | undefined;
      };
  readonly onRetry?: (() => void) | undefined;
};

export function PolicyVersionScore({
  score,
  onRetry,
}: PolicyVersionScoreProps) {
  return (
    <Card>
      <Stack width="auto">
        <Heading level={2}>Version score</Heading>
        {score.status === "empty" ? (
          <Text tone="muted">No completed episodes for this version yet.</Text>
        ) : (
          <PolicyStateFeedback
            state={score}
            subject="version score"
            onRetry={onRetry}
          />
        )}
        {score.status === "ready" && (
          <div>
            <Text as="p" size="small" tone="muted">
              Mean score
            </Text>
            <p {...stylex.props(styles.score)}>{score.value}</p>
            <Text size="small" tone="muted">
              Over {score.episodes} completed episode
              {score.episodes === 1 ? "" : "s"} for this version
            </Text>
          </div>
        )}
      </Stack>
    </Card>
  );
}

const styles = stylex.create({
  score: {
    fontFamily: fonts.interface,
    fontSize: fontSizes.display,
    fontVariantNumeric: "tabular-nums",
    margin: 0,
  },
});
